<template>
    <div class="brt-label-header-module" :border="border">
        <div class="brt-lh-before">
            <span v-if="title">{{ title }}</span>
            <slot v-else name="before"></slot>
        </div>
        <div class="brt-lh-after">
            <slot name="after"></slot>
        </div>
        <div class="brt-lh-middle">
            <slot name="middle"></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "LabelHeader",
        props: {
            title: {
                default: ''
            },
            border: {
                default: false
            }
        }
    }
</script>

<style lang="less">
    @import "../../styles/comm.less";

    .brt-label-header-module {
        position: relative;
        height: 45px;
        line-height: 45px;
        padding: 0 @SpacingNumber;
        color: @FontColorA1;
        margin-bottom: 1px;

        &[border] {
            border-bottom: 1px solid @BorderColorA2;
        }
        &[border='top'] {
            border-bottom: none;
            border-top: 1px solid @BorderColorA2;
        }
        &[border='top-bottom'] {
            border-top: 1px solid @BorderColorA2;
        }

        > .brt-lh-before {
            float: left;
        }

        > .brt-lh-after {
            float: right;
        }

        .brt-lh-middle {
            position: absolute;
            left: 20%;
            right: 20%;
            top: 0;
            text-align: center;
        }

    }
</style>
